import { EmployeeGeneralData } from '@pxtra-client-lib-legacy/gen';
import { FC } from 'react';
import { Avatar, Loading } from '../../../../lib/components';

interface Props {
  data: EmployeeGeneralData | undefined;
}

export const ProfilePictureView: FC<Props> = ({ data }) => {
  return data ? (
    <Avatar
      variant="rounded"
      sx={{
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'grey.50',
        backgroundColor: 'white',
        width: '100%',
        height: 470,
        borderRadius: '.75rem'
      }}
      src={`${data.profile_picture?.url}`}
      imgProps={{
        style: { objectFit: 'contain' }
      }}
    />
  ) : (
    <Loading />
  );
};
